export default {
  name: "Nama",
  tel: "Telefon",
  save: "Simpan",
  confirm: "Sahkan",
  cancel: "Batal",
  delete: "Padam",
  complete: "Selesai",
  loading: "Sedang dimuat...",
  telEmpty: "Sila isi nombor telefon",
  nameEmpty: "Sila isi nama",
  nameInvalid: "Sila masukkan nama yang sah",
  confirmDelete: "Adakah anda pasti ingin padam?",
  telInvalid: "Sila masukkan nombor telefon yang sah",
  SelectYearMonthDay: "Pilih Tahun, Bulan, Hari",
  vanCalendar: {
    end: "Tamat",
    start: "Mula",
    title: "Pilih Tarikh",
    confirm: "Sahkan",
    startEnd: "Mula/Tamat",
    weekdays: ["Ahd", "Isn", "Sel", "Rab", "Kha", "Jum", "Sab"],
    monthTitle: (year, month) => `${year} Tahun ${month} Bulan`,
    rangePrompt: (maxRange) =>
      `Hari yang dipilih tidak boleh melebihi ${maxRange} hari`,
  },
  vanCascader: {
    select: "Sila pilih",
  },
  vanContactCard: {
    addText: "Tambah Kenalan",
  },
  vanContactList: {
    addText: "Kenalan Baru",
  },
  vanPagination: {
    prev: "Halaman Sebelumnya",
    next: "Halaman Seterusnya",
  },
  vanPullRefresh: {
    pulling: "Tarik ke bawah untuk muat semula...",
    loosing: "Lepaskan untuk muat semula...",
  },
  vanSubmitBar: {
    label: "Jumlah:",
  },
  vanCoupon: {
    unlimited: "Tiada had penggunaan",
    discount: (discount) => `${discount} Diskaun`,
    condition: (condition) => `Sah untuk pembelian melebihi RM${condition}`,
  },
  vanCouponCell: {
    title: "Kupon",
    tips: "Tiada kupon tersedia",
    count: (count) => `${count} tersedia`,
  },
  vanCouponList: {
    empty: "Tiada kupon",
    exchange: "Tebus",
    close: "Jangan guna kupon",
    enable: "Tersedia",
    disabled: "Tidak tersedia",
    placeholder: "Masukkan kod kupon",
  },
  vanAddressEdit: {
    area: "Kawasan",
    postal: "Poskod",
    areaEmpty: "Sila pilih kawasan",
    addressEmpty: "Sila isi alamat lengkap",
    postalEmpty: "Format poskod tidak sah",
    defaultAddress: "Tetapkan sebagai alamat utama",
    telPlaceholder: "No. telefon penerima",
    namePlaceholder: "Nama penerima",
    areaPlaceholder: "Pilih Negeri / Bandar / Daerah",
  },
  vanAddressEditDetail: {
    label: "Alamat Penuh",
    placeholder:
      "Nama jalan, nombor rumah, tingkat, nombor bilik dan lain-lain",
  },
  vanAddressList: {
    add: "Tambah Alamat",
  },

  unionManagement: {
    GuildRegistration: "Pendaftaran Persekutuan",
    ApplicantID: "ID Pemohon",
    GuildName: "Nama Persekutuan",
    PleaseGuildName: "Sila masukkan nama guild",
    PleaseGuildID: "Sila masukkan ID Persekutuan",
    PleaseInformation: "Sila masukkan maklumat perhubungan anda",
    PlatformsWith: "Platform yang pernah anda bekerjasama",
    ListOfplatforms: "Senaraikan platform yang pernah anda bekerjasama",
    GuildSize: "Saiz Persekutuan",
    EstimatedNumber: "Anggaran bilangan hos persekutuan",
    Notes:
      "Nota: Anda boleh hubungi ketua persekutuan atau ahli persekutuan untuk mendapatkan ID persekutuan.",
    Submit: "Hantar",
    SubmitSuccess: "Berjaya dihantar",
    MyGuild: "Persekutuan Saya",
    VoiceHallOnboarding: "Pendaftaran Dewan Suara",
    VoiceHallName: "Nama Dewan Suara",
    PleaseVoiceHallName: "Sila masukkan nama dewan suara",
    WhatsApp: "WhatsApp",
    PleaseContactInfo: "Sila masukkan maklumat perhubungan anda",
    PlatformsCollaborated: "Platform yang pernah bekerjasama",
    ListPlatformsCollaborated: "Senaraikan platform yang pernah bekerjasama",
    VoiceHallScale: "Skala Dewan Suara",
    EstimatedAnchors: "Anggaran bilangan penyampai dewan suara",
    CertificationType: "Jenis Pengesahan",
    VoiceHall: "Dewan Suara",
    VoiceGuild: "Persatuan Suara",
    HostName: "Nama Hos",
    GuildJoinDate: "Tarikh Sertai Persekutuan",
    TotalMembers: "Jumlah Keseluruhan Ahli Persekutuan",
    TotalPeople: "Jumlah Keseluruhan Orang",
    DataDetails: "Butiran Data",
    PleaseHostID: "Sila masukkan ID hos",
    Search: "Cari",
    KickOut: "Tendang Keluar",
    NoData: "Tiada data tersedia",

    InformationData: "Data Maklumat",
    Name: "Nama",
    PleaseID: "Pastikan ia sepadan dengan nama pada kad pengenalan anda.",
    IdentityCard: "Kad Pengenalan",
    YourIDnumber: "Nombor Kad Pengenalan Anda",
    IDPhoto: "Foto Kad Pengenalan",
    PleasePhoto: "Sila muat naik foto kad pengenalan anda.",
    FrontofID: "Bahagian Hadapan Kad Pengenalan",
    BackofID: "Bahagian Belakang Kad Pengenalan",
    NotePlease:
      "Nota: Muat naik foto anda memegang kad pengenalan. Wajah mesti jelas tanpa halangan, dan foto serta nombor pada kad pengenalan mesti jelas terbaca.",
    Country: "Negara",
    SelectCountryorRegion: "Pilih Negara/Kawasan",
    BankName: "Nama Bank",
    Pleasebankname: "Sila masukkan nama bank tempat anda membuka akaun.",
    BankCardNumber: "Nombor Akaun Bank",
    Pleasebankcardnumber: "Sila masukkan nombor akaun bank anda.",
    BankCardHolder: "Pemilik Akaun Bank",
    Pleasebankcardholder: "Sila masukkan nama pemilik akaun bank.",
    PhoneNumber: "Nombor Telefon",
    Enterphonenumber: "Masukkan nombor telefon yang sah.",
    Notebankaccount:
      "Nota: Sila masukkan nombor telefon yang didaftarkan dengan bank anda.",
    WhatsAppContactInformation: "Maklumat Hubungan WhatsApp",
    Pleaseownnumber: "Pastikan anda memasukkan nombor telefon anda sendiri.",
    Notecollaborationmatters:
      "Nota: Maklumat WhatsApp yang diberikan oleh persatuan akan dianggap sebagai satu-satunya saluran hubungan untuk urusan kerjasama.",
    Email: "E-mel",
    Pleaseemailaddress: "Pastikan anda memasukkan alamat e-mel anda sendiri.",
    Notematters:
      "Nota: E-mel yang disediakan oleh persatuan akan dianggap sebagai satu-satunya saluran hubungan untuk urusan kerjasama.",

    SpecialGiftDetails: "Butiran Hadiah Efek Khas",
    CurrentDate: "Tarikh Semasa",
    GoldCoinTransactions: "Penghasilan Beruntung Gold Bean",
    LiveStreamingDuration: "Tempoh Siaran Langsung",
    GoldBeanEarnings: "Pendapatan Kacang",
    EffectiveDays: "Hari Berkesan",
    WarningCount: "Bilangan Amaran",

    give: "bagi",
    pleasewait: "Permintaan sedang diproses, sila tunggu...",

    JoinGuild: "Sertai Persatuan",
    GuildId: "ID Persatuan",
    PlaceholderGuildId: "Sila Masukkan ID Persatuan",

    InvitationCode: "Kod jemputan",
    noMore: "Tiada lagi",

    Recommendation: "Rekomendasi (Opsional)",
    nightLiveTime: "Waktu tertentu",

    // Halaman Data Guild
    GuildIncome: "Pendapatan Guild",
    AnchorIncome: "Pendapatan Anchor",
    EffectiveLive: "Siaran Langsung Berkesan",
    EffectiveDays: "Hari Berkesan",
    Income: "Pendapatan",
    Duration: "Tempoh Masa",
  },

  familyMain: {
    anchorList: "Senarai Anchor",
    anchorData: "Data Anchor",
    micTime: "Masa Mic",
    micTimeData: "Data masa Mic",
    beansDetail: "Perincian Kacang",
    beansDetailData: "Data perincian Kacang",
    withdrawDetail: "Perincian pengeluaran",
    withdrawDetailData: "Data perincian pengeluaran",
    roomData: "Data bilik",
    roomDataData: "Data bilik",
    distributeBeans: "Agihan Kacang",
    distributeBeansData: "Data agihan Kacang",
    privateShareStats: "Statistik mesej/kongsi",
    privateShareStatsData: "Data statistik mesej/kongsi",
    roomTurnover: "Pusingan bilik",
    roomTurnoverData: "Data pusingan bilik",
    incomeRecord: "Rekod pendapatan",
    incomeRecordData: "Data rekod pendapatan",
    knapsackGiftDetail: "Perincian hadiah beg",
    knapsackGiftData: "Data hadiah beg",
    roomFilterTitle: "Penapis Bilik",
    roomFilterConfirm: "Selesai",
    allRooms: "Semua bilik",
  },
  anchorList: {
    countLabel: "【{count} hos】",
    searchPlaceholder: "Masukkan ID hos",
    search: "Cari",
    joinTimeLabel: "Waktu menyertai：",
    noData: "Tiada data",
    nickNameFallback: "Nama hos",
    invalidUserId: "Sila masukkan ID angka",
  },

  salaryMain: {
    searchPlaceholder: "Masukkan ID anchor untuk cari",
    dateSelect: "Pilih tarikh",
    byDay: "Mengikut hari",
    byRange: "Mengikut julat",
    searchTime: "Masa carian",
    to: " hingga ",
    dataSummary: "Ringkasan data",
    totalMicTime: "Jumlah masa Mic",
    totalHeartGiftTurnover: "Jumlah Kacang Emas Bertuah",
    totalLuxuryGiftTurnover: "Jumlah Kacang Emas",
    member: "Ahli",
    anchorProfile: "Profil Anchor",
    micTime: "Masa Mic",
    heartGiftTurnover: "Kacang Emas Bertuah",
    luxuryGiftTurnover: "Jumlah Kacang Emas",
    roomNumber: "Nombor bilik",
    pleaseSelectTime: "Pilih masa",
    pleaseEnterNumber: "Sila masukkan nombor",
    selectAll: "Pilih semua",
    minute: "min",
    second: "saat",
  },

  anchorCenter: {
    todayLiveData: "Data siaran hari ini",
    time: "Masa",
    duration: "Tempoh",
    income: "Pendapatan Kacang Emas Bertuah",
    giftRecord: "Rekod hadiah",
    withdraw: "Pengeluaran",
    tipsUpdate: "Nota: Data hari ini dikemas kini setiap minit",
    overallData: "Data keseluruhan",
    totalDays: "Jumlah hari",
    totalDuration: "Jumlah tempoh",
    totalTurnover: "Jumlah Kacang Emas Bertuah",
    totalIncome: "Jumlah gaji asas",
    totalBeans: "Jumlah kacang emas",
    luckyBeans: "Kacang emas bertuah",
    specialBeans: "Kacang emas efek khas",
    baseSalary: "Gaji asas",
    totalIncomeLabel: "Jumlah pendapatan",
  },

  micTime: {
    searchPlaceholder: "Masukkan ID anchor",
    search: "Cari",
    dateSelect: "Pilih tarikh",
    today: "Hari ini",
    thisWeek: "Minggu ini",
    lastWeek: "Minggu lepas",
    totalMicTime: "Jumlah masa Mic",
    date: "Tarikh",
    anchorInfo: "Maklumat Anchor",
    micTime: "Masa Mic",
    pleaseSelectTime: "Pilih masa",
    selectAll: "Pilih semua",
    minute: "min",
    second: "saat",
  },

  anchroOtayonii: {
    dateSelect: "Pilih tarikh",
    byDay: "Mengikut hari",
    byRange: "Mengikut julat",
    searchTime: "Masa carian",
    to: " hingga ",
    dataSummary: "Ringkasan data",
    totalLuckyGift: "Jumlah hadiah Lucky",
    totalSpecialGift: "Jumlah hadiah Special",
    totalKnapsackGift: "Jumlah hadiah Knapsack",
    anchorInfo: "Maklumat Anchor",
    luckyGift: "Hadiah Lucky",
    specialGift: "Hadiah Special",
    knapsackGift: "Hadiah Knapsack",
    pleaseSelectTime: "Pilih masa",
    selectAll: "Pilih semua",
  },

  roomCm: {
    dateSelect: "Pilih tarikh",
    today: "Hari ini",
    thisWeek: "Minggu ini",
    lastWeek: "Minggu lepas",
    dataSummary: "Ringkasan data",
    totalTurnover: "Jumlah Kacang Emas Bertuah",
    totalTurnoverBeans: "Jumlah Kacang Emas",
    date: "Tarikh",
    heartGiftTurnover: "Kacang Emas Bertuah",
    specialGiftTurnover: "Jumlah Kacang Emas",
    room: "Bilik",
    pleaseSelectTime: "Pilih masa",
    selectAll: "Pilih semua",
    minute: "min",
    second: "saat",
  },

  weekProfit: {
    dateSelect: "Pilih tarikh",
    time: "Masa",
    type: "Jenis",
    beans: "Kacang",
    pleaseSelectTime: "Pilih masa",
  },

  //提现记录
  withdrawRecord: {
    withdrawAmount: "Jumlah Pengeluaran",
    withdrawStatus: "Status Pengeluaran",
    NoData: "Tiada data tersedia",

    UnderReview: "Dalam Semakan",
    Processing: "Sedang Diproses",
    Completed: "Selesai",
    Rejected: "Ditolak",
    Failed: "Gagal",

    Pending: "Menunggu",
    Success: "Berjaya",
    NoMore: "Tiada lagi",
    PleaseWait: "Sila tunggu...",
    PleaseSelect: "Sila pilih",
    Date: "Tarikh",
    RealAmount: "Jumlah Sebenar",
    Fee: "Yuran",
    Status: "Status",
    Remark: "Catatan",
  },

  coinManagement: {
    myGoldenbeans: "Kacang Emas Saya",
    Withdraw: "Pengeluaran",
    ExchangeGoldCoins: "Tukar",
    HostInformation: "Maklumat Hos",
    WithdrawalCurrency: "Mata Wang Pengeluaran",
    SelectWithdrawalCurrency: "Sila pilih mata wang pengeluaran",
    FiatCurrency: "Mata Wang Fiat",
    PleaseSelectWithdrawalCurrency: "Sila pilih mata wang pengeluaran",
    tips: "Nota：",
    tipsp0: "1. Kadar pengeluaran: 10,000 kacang emas = 0.5 USD",
    tipsp1:
      "2、Had pengeluaran: 100,000 biji emas, pengeluaran hanya boleh dilakukan dalam gandaan 10,000",
    tipsp2:
      "3、Pautkan akaun pengeluaran. Disebabkan oleh pelbagai kaedah pembayaran dan kekurangan dokumen tetap di luar negara, sistem belakang memerlukan pelbagai jenis pengesahan apabila menambah akaun sebagai ketua keluarga (kaedah pembayaran tertentu bergantung kepada keadaan semasa).",
    tipsp3: "4、Sama ada pengesahan identiti telah selesai",
    tipsp4: "5、Pautkan nombor telefon",
    tipsp5:
      "Jika mana-mana langkah di atas tidak lengkap, pengeluaran tidak dapat diteruskan. Pada ketika ini, halaman akan memberi tahu pengguna atau membimbing mereka untuk menyelesaikan proses.",
    tipsp6: "① Hanya pemberitahuan",
    tipsp7:
      "② Alihkan ke halaman pautan nombor telefon. Selepas selesai, kembali ke halaman sebelumnya.",
    tipsp8:
      "③ Alihkan ke halaman pengesahan identiti. Selepas selesai, kembali ke halaman sebelumnya.",
    tipsp9:
      "④ Alihkan ke halaman pautan akaun. Selepas selesai, kembali ke halaman sebelumnya.",
    tipsp10:
      "3、Pengeluaran tunai akan mempunyai yuran tertentu, dan yuran akan berbeza mengikut saluran yang berbeza.",

    tipsp11: "1. Kadar pertukaran: 1000 kacang emas = 500 syiling emas",
    tipsp12: "2. Minimum 5000 kacang emas untuk ditukar, mestilah gandaan 1000",
    tipsp13:
      "3. Pertukaran yang berjaya tidak boleh ditarik balik, sila berhati-hati semasa menukar",
    num: "Kuantiti",
    Custom: "Tersuai",
    PleaseEnter: "Sila masukkan",
    Redeem: "Tebus",
    SelectType: "Pilih Jenis",
    GoldBeans: "Kacang Emas",
    GoldCoin: "Syiling",
    WithdrawalAmount: "Jumlah Pengeluaran",
    PleaseNum: "Masukkan jumlah coin untuk dikeluarkan",
    All: "Semua",
    Withdraw: "Keluarkan",

    Incomedetails: "Perincian pendapatan",
    Expensedetails: "Perincian perbelanjaan",
    Nobeans: "Tiada kacang emas yang boleh ditebus",

    balance: "Baki",

    Record: "Rekod Transaksi",
    WithdrawalRecord: "Rekod Pengeluaran",
  },

  contactUs: {
    Officialcustomerservice: "Perkhidmatan Pelanggan Rasmi",
    ContactUs: "Hubungi Kami",
    Issueofguild: "Masalah Pendaftaran Kesatuan",
  },

  myInvitation: {
    MyGoldBeans: "Kacang Emas Saya",
    Share: "Kongsi untuk Menjemput Lebih Ramai Rakan",
    CopyLink: "Salin Pautan",
    GoldCoinEarnedToday: "Syiling Emas Diperoleh Hari Ini",
    TotalGoldCoin: "Jumlah Syiling Emas Terkumpul",
    tips: "Jemput dan Pautkan Pengguna Baharu untuk Menambah Nilai Sebarang Jumlah dan Dapatkan Ganjaran 1% Emas",
    tips2: "Tidak boleh mengikat selepas 48 jam pendaftaran",
    MyInvitations: "Jemputan Saya",
    BillingDetails: "Butiran Bil",
    Total: "Jumlah",
    People: "Orang",
    GoldCoinGiven: "Syiling Emas Diberikan",
    GiveGoldCoin: "Tambah+",
  },

  userMisconduct: {
    title1: "Pelanggaran Kandungan I",
    p1: "1.Memaparkan atau Menyebarkan Kandungan Terhad:",
    p2: "Termasuk menyebarkan kandungan lucah, kasar, keganasan, atau perkauman melalui mesej peribadi, siaran langsung, atau ciri lain Rain Live.",
    p3: "2.Menyebarkan Ucapan Kebencian:",
    p4: "Dilarang membuat ucapan kebencian yang ditujukan kepada agama, kaum, politik, atau identiti negara.",
    p5: "3.Promosi atau Rekrutmen:",
    p6: "Dilarang menjemput pengguna menyertai aplikasi atau platform lain melalui siaran langsung, mesej peribadi, atau komen yang telah ditinjau.",
    title2: "Akibat",
    p7: "Akaun, peranti, atau alamat IP yang melanggar boleh disekat.",

    title3: "Pelanggaran Kandungan II",
    p8: "1.Berkongsi Maklumat Peribadi:",
    p9: "Dilarang menyebarkan maklumat peribadi seperti nombor telefon, ID akaun, akaun Facebook, atau gambar melalui siaran langsung, komen, atau mesej peribadi Rain Live.",
    p10: "2.Penyalahgunaan Akaun:",
    p11: "Dilarang memberikan, menyewakan, atau menjual akaun Rain Live kepada orang lain.",
    p12: "3.Menggunakan Maklumat Peribadi:",
    p13: "Dilarang menggunakan atau menyebarkan maklumat peribadi (gambar, nama samaran, dll.) tanpa kebenaran pengguna untuk keuntungan peribadi atau menyerang orang lain dengan niat jahat.",
    title4: "Akibat",
    p14: "Pengguna yang melanggar akan disekat secara kekal.",
  },

  landingPage: {
    info1: "Lingkaran Rain Live",
    info2: "Pembelian Dalaman Apl",
    item1: "45K Ulasan",
    item2: "Muat Turun",
    item3: "Tahap 3 3+",
    btn: "Muat Turun",
    title: "Tentang Rain Live",
    content:
      "Rain Live ialah aplikasi siaran langsung dalam talian yang menyentuh hati untuk semua orang, termasuk suara, video, hiburan, dan permainan. Platform ini mengumpulkan hos dengan profil tinggi dan berfungsi sebagai platform siaran langsung yang kaya dengan kandungan. Pertandingan PK sengit, acara tanpa henti, hadiah hebat, dan Experience seperti raja menunggu.",
    tips: "Rain Live menduduki tempat pertama dalam senarai aplikasi sosial percuma popular.",
  },

  equityLevel: {
    Experience: "Poin Experience",
    Level: "Tahap Semasa",
    Berikutnya: "Jarak ke Tahap Seterusnya",
    title1: "Keistimewaan Tahap",
    desc1:
      "Semakin tinggi tahap, semakin terhormat tahap ikon, dan semakin mudah menarik perhatian hos kegemaran anda.",
    title2: "Cara Meningkatkan",
    desc2:
      "1、Tahap pengguna ditentukan oleh jumlah Experience yang diperoleh daripada penggunaan hadiah.",
    desc3:
      "2、Anda boleh meningkatkan tahap dengan memberi hadiah setiap hari untuk memperoleh mata Experience.",
    desc4:
      "3、Hadiah bertuah, setiap 1 syiling yang dibelanjakan, anda memperoleh 1 mata Experience.",
    desc5:
      "4、Hadiah kesan khas, setiap 1 syiling yang dibelanjakan, anda memperoleh 10 mata Experience.",
    title3: "Keistimewaan Tahap",
    desc6:
      "Semakin tinggi tahap, semakin terhormat tahap ikon, dan semakin mudah menarik perhatian pengguna.",
    title3: "Cara Meningkatkan",
    desc7:
      "1、Tahap hos ditentukan oleh jumlah Experience yang diperoleh daripada menerima hadiah.",
    desc8:
      "2、Anda boleh meningkatkan tahap dengan menerima hadiah setiap hari untuk memperoleh mata Experience.",

    title6: "Tahap pengguna",
    title7: "Tahap",
    title8: "Lencana tahap",
    title9: "Tahap Hos",
    title10: "Jumlah mata pengalaman",

    LevelDescription: "Penerangan tahap",
  },

  applyJoin: {
    tips1: "Masukkan akaun WhatsApp anda",
    title2: "Keperluan gambar",
    tips2:
      "Sila tunjukkan muka dan bahagian atas badan anda, dan posisikan tangan anda dalam gaya seperti kucing",
    tips3:
      "Foto ini akan diambil untuk tujuan semakan syarikat sahaja, dan pihak berkuasa akan menyimpannya secara sulit.",
    tips4: "Foto mestilah gambar diri anda sendiri.",
    title3: "Keperluan video",
    tops5: "Video mesti memaparkan individu tersebut.",
    tips6: "Video perlu berdurasi antara 10 hingga 20 saat.",
    status1: "Hantar untuk semakan",
    status2: "Sedang disemak",
    status3: "Semakan berjaya",
    status4: "Semakan gagal",

    LiveMode: "Mod siaran langsung",
    Video: "Video",
    Voice: "Suara",

    MP4: "Sila pilih video dalam format MP4",
    pngOrJpg: "Sila muat naik imej dalam format PNG atau JPG",
    UploadingWait: "Sedang memuat naik, sila tunggu",
    CompleteInformation: "Sila lengkapkan maklumat",
  },
  cancelAccount: {
    title: "Memohon Penghapusan Akaun",
    tips: "Maklumat berikut akan dipadamkan dan tidak boleh dipulihkan:",
    p1: "Selepas akaun dipadamkan, semua maklumat akan dipadamkan secara kekal (termasuk pengikut, peminat, dll.), dan perkhidmatan berbayar yang telah anda beli tidak akan disimpan atau dipindahkan ke akaun lain (seperti VIP, nombor cantik, bingkai avatar, dll.).",
    p2: "Akaun Facebook, Twitter, Apple, dan Google yang dihubungkan akan dinyah paut. Selepas dinyah paut, anda boleh mendaftar semula.",
    p3: "Maklumat aplikasi Hos anda akan dinyah paut, dan selepas dinyah paut, anda boleh menghubungkannya ke akaun lain. (Jika anda ialah pengguna Hos siaran langsung, maklumat Hos anda boleh disahkan semula untuk siaran langsung).",
    p4: "Selepas akaun dipadamkan, baki syiling emas, berlian, mata pengalaman, kenderaan, status bangsawan, dan data hasil lain akan dipadamkan. Sebarang kerugian akan ditanggung oleh pemohon penghapusan akaun.",
    p5: "Jika anda ialah ketua persatuan, permohonan penghapusan akaun akan secara automatik membubarkan persatuan. (Jika persatuan dibubarkan, permohonan yang ditarik balik tidak dapat memulihkan persatuan). Jika anda ialah ahli persatuan, penghapusan akaun akan secara automatik mengeluarkan anda dari persatuan (anda boleh membatalkan permohonan dalam masa 15 hari untuk memulihkan).",
    p6: "Jika anda ialah ketua keluarga, anda perlu membubarkan atau keluar dari keluarga sebelum memohon penghapusan akaun.",
    p7: "Jika anda ialah ahli keluarga (bukan ketua), permohonan penghapusan akaun akan segera mengeluarkan anda dari keluarga (penghapusan dalam tempoh rayuan 15 hari tidak boleh memulihkan keahlian keluarga).",
    p8: "Selepas menyerahkan permohonan penghapusan, terdapat tempoh rayuan selama 15 hari. Log masuk dalam tempoh ini akan membatalkan penghapusan secara automatik. Selepas tempoh rayuan tamat, akaun akan dipadamkan secara kekal dan tidak boleh dipulihkan. Jika akaun perlu dipulihkan kerana tindakan tidak sah atau kesilapan, sila hubungi khidmat pelanggan untuk rayuan. (WhatsApp Khidmat Pelanggan: +62 81188011180, atau e-mel: rainlive888@gmail.com).",
  },

  Proxy: {
    Hello: "Hai,",
    Welcome: "Selamat datang di Rain Live!",
    Account: "Akaun",
    Pleaseenter: "Sila masukkan",
    Password: "Kata laluan",
    Login: "Log",
    MyAgent: "Ejen saya",
    Nickname: "Nama samaran agensi",
    CoinBalance: "Baki syiling agensi",
    TransferRecord: "Sejarah pindahan",
    Recharge: "Tambah nilai",
    TransferInformation: "Sila isi maklumat pindahan",
    Reset: "Tetapkan semula",
    RecipientID: "ID Penerima",
    RecipientNickname: "Nama samaran penerima",
    TransferAmount: "Jumlah pindahan",
    Transfer: "Pindahan",
    KindReminder: "Peringatan",
    DoubleCheck: "Sila semak semula maklumat supaya tiada ralat",
    SelectAmount: "Sila pilih jumlah untuk tambah nilai",
    SelectMonth: "Pilih bulan",
    Username: "Nama pengguna",
    TransferTime: "Waktu pindahan",
    AutoFill: "Isi Automatik",
    Rechargeselection: "Muat semula pemilihan",
    ProxyCurrency: "Syiling Ejen Tidak Mencukupi",
    PaymentAmount: "Jumlah pembayaran",
    PleaseSelectAmount: "Sila pilih jumlah untuk tambah nilai",
  },
  bd: {
    index: {
      guildCount: "Jumlah Persatuan",
      weekEstimatedIncome: "Pendapatan Mingguan",
      lastWeekIncome: "Pendapatan Mingguan",
      inviteCode: "Kod Jemputan",
      copySuccess: "Kod Jemputan berjaya disalin",
      searchPlaceholder: "Masukkan ID Persatuan",
      enterGuildId: "Sila masukkan ID Persatuan",
      searchGuild: "Cari Persatuan",
      lastWeek: "Minggu Sebelumnya",
      weekIncome: "Pendapatan Mingguan",
      myIncome: "Pendapatan Saya",
      effectiveLive: "Jumlah Siaran Langsung",
      bindDays: "Jumlah Hari",
      summary: "Ringkasan",
      guildName: "Nama Persatuan",
      guildId: "ID Persatuan",
      guildIncome: "Pendapatan Persatuan",
      effectiveLive: "Jumlah Siaran Langsung",
      myIncome: "Pendapatan Saya",
      date: "Tarikh",
      noData: "Tiada data tersedia",
      searching: "Mencari data pendapatan",
      showingSummary: "Tampilkan ringkasan data",
      loading: "Memuatkan data...",
      loadFailed: "Gagal memuatkan data",
      networkError: "Ralat jaringan, sila cuba lagi nanti",
      selectWeek: "Pilih Tempoh",
      thisWeek: "Minggu Ini",
      lastWeek: "Minggu Sebelumnya",
      beforeLastWeek: "Minggu Sebelum Minggu Sebelumnya",
      thisMonth: "Bulan Ini",
      lastMonth: "Bulan Sebelumnya",
    },
    incomeDetail: {
      title: "Butiran Pendapatan",
      lastWeekIncome: "Pendapatan Mingguan",
      totalIncome: "Pendapatan Total",
      guildId: "ID Persatuan",
      date: "Tarikh",
      thisWeek: "Minggu Ini",
      lastWeek: "Minggu Sebelumnya",
      beforeLastWeek: "Minggu Sebelum Minggu Sebelumnya",
      thisMonth: "Bulan Ini",
      lastMonth: "Bulan Sebelumnya",
      guildName: "Nama Persatuan",
      guildIncome: "Pendapatan Persatuan",
      effectiveLive: "Jumlah Siaran Langsung",
      myIncome: "Pendapatan Saya",
      search: "Cari",
      showSummary: "Tampilkan Ringkasan",
      noData: "Tiada data tersedia",
      searching: "Mencari data pendapatan",
      showingSummary: "Tampilkan ringkasan data",
    },
  },
  noble: {
    expireTime: "Masa Tamat",
    canReceive: "Dapatkan {coin} syiling",
    receive: "Terima Sekarang",
    received: "Sudah Terima",
    becomeNoble: "Aktifkan",
    totalCanGet: "Jumlah yang boleh dapatkan {price}{totalCoin} syiling",
    silver: "Perak",
    gold: "Emas",
    platinum: "Platinum",
    diamond: "Berlian",
    obsidian: "Black Obsidian",
    privileges: {
      getCoin: "Dapatkan Syiling",
      avatarFrame: "Bingkai Avatar",
      medal: "Medali",
      vehicle: "Kenderaan",
      purchaseNotification: "Pemberitahuan Pembelian",
      chatBubble: "Bubur Chat",
      colorfulNickname: "Nama Samaran Berwarna",
      specialId: "ID Khas",
      mystery: "Rahsia",
      exclusiveService: "Perkhidmatan Eksklusif",

      title: "Privileges Eksklusif",
      Effect: "Efek Masuk Bilik",
    },
    contactOperation: "Hubungi Operasi",
    receiveSuccess: "Terima syiling berjaya",
    level1Recharge: " Silver VIP / 30 hari",
    level2Recharge: "Gold VIP / 30 hari",
    level3Recharge: "Platinum VIP / 30 hari",
    level4Recharge: "Diamond VIP / 30 hari",
    level5Recharge: "Black VIP / 30 hari",
  },
  bonusActivity: {
    title: "Aktiviti Bonus Siaran Langsung",
    activityTime: "Tempoh Aktiviti: 7 Apr 00:00 - 4 Mei 23:59:59(UTC+8)",
    rewardRules: "Peraturan Ganjaran",
    reward: "Ganjaran",
    totalReceived: "Jumlah Diterima",
    bonus: "Bonus",
    claim: "Tuntut",
    claimed: "Telah Dituntut",
    notAchieved: "Tidak Dicapai",
    duration: "Tempoh (Jam)",
    target: "Sasaran (Syiling)",
    note: "Nota: Selepas mencapai sasaran, bonus boleh dituntut pada hari berikutnya",
    activityCalendar: "Kalendar Aktiviti",
    april: "April",
    may: "Mei",
    claimSuccess: "Berjaya Dituntut",
  },
  bonusActivityRule: {
    activityDescription: "Penerangan Aktiviti",
    descriptionContent:
      "Selain daripada ganjaran asas, hos akan menerima bonus tambahan daripada Rain Live.",
    activityTime: "Tempoh Aktiviti",
    timeContent1: "7 April 2025 hingga 4 Mei 2025 (UTC+8)",
    timeContent2:
      "Pada 0:00 (UTC+8) setiap hari, ganjaran hari berikutnya akan diaktifkan",
    claimMethod: "Kaedah Tuntutan",
    claimContent:
      "Apabila sasaran dicapai pada hari semasa, ganjaran boleh dituntut secara manual pada hari berikutnya.",
    rewardTable: "Jadual Ganjaran:",
    targetTurnover: "Sasaran Perolehan",
    activityReward: "Ganjaran Aktiviti",
  },
  inviteFriends: {
    invitationEventTitle: "Acara Jemputan",
    inviteAndEarnRewards: "Jemput & Dapatkan Ganjaran",
    eventPeriod: "Tempoh Acara: 7 April 00:00 - 4 Mei 23:59:59 (UTC+8)",
    invitationRecord: "Rekod Jemputan",
    eventDetails: "Butiran Acara",
    week1DateRange: "Minggu Pertama: 7 April - 13 April",
    totalInvitedExample: "Jumlah Jemputan",
    level1RewardText: "Lv.1 Jemput 20 orang 20000 Syiling",
    level2RewardText: "Lv.2 Jemput 50 orang 50000 Syiling",
    level3RewardText: "Lv.3 Jemput 100 orang 100000 Syiling",
    statusClaimed: "Sudah Ditebus",
    actionClaim: "Tebus",
    statusNotAchieved: "Belum Dicapai",
    topUpRewardsLabel: "Ganjaran Tambah Nilai:",
    copyInvitationLink: "Salin Pautan Jemputan",
    rewardNote:
      "Nota: Apabila pengguna yang dijemput membuat tambah nilai, anda akan menerima 2% daripada jumlah syiling sebagai ganjaran.",
    copySuccess: "Salin Berjaya",
    claimSuccessExample: "Berjaya Menebus 20000 Syiling",
    userIDLabel: "User ID",
    userNameLabel: "Nama Pengguna",
    timeLabel: "Masa",
    topUpLabel: "Tambah Nilai",
    eventPurposeTitle: "【Tujuan Acara】",
    eventPurposeDesc:
      'Sebagai tanda penghargaan atas sokongan dan kasih sayang pengguna terhadap Rain Live, platform ini melancarkan acara "Jemput Rakan & Nikmati Pelbagai Ganjaran". Kami menjemput anda dan rakan-rakan untuk menikmati pengalaman penstriman langsung yang menarik!',
    eventDurationTitle: "【Tempoh Acara】",
    eventDateRange: "7 April 2025 – Mei 2025",
    eventCycleDesc:
      "Jumlah 4 minggu, dengan ganjaran baharu bermula setiap hari Isnin pada 00:00 (UTC+8).",
    rewardRulesTitle: "【Peraturan Ganjaran】",
    rewardRulesDesc1:
      "Selain ganjaran daripada acara ini, anda juga akan terus menerima bonus jemputan asal:",
    rewardRulesDesc2:
      "2% daripada jumlah syiling tambah nilai pengguna yang dijemput akan diberikan kepada penjemput sebagai ganjaran tambahan.",
    importantNotesTitle: "【Nota Penting】",
    importantNotesDesc:
      "⚠️ Dilarang menggunakan akaun palsu, pendaftaran bot, atau tindakan curang lain untuk mendapatkan ganjaran. Jika dikesan, semua ganjaran akan ditarik balik serta-merta, dan sekatan akaun mungkin dikenakan.",
  },
  bonusPoints: {
    activityTime: "Waktu Aktiviti",
    resetTime: "Diset semula setiap hari pada 00:00 (UTC+8)",
    pointsReward: "Ganjaran Mata",
    coinsReward: "Ganjaran Syiling",
    participationTimes: "Sertai {times} kali",
    points: "Mata",
    exchange: "Tebus",
    pointsMall: "Kedai Mata",
    betSum: "Jumlah Pertaruhan Semasa",
    note: "Nota",
    rule1: "1.Poin diperoleh dengan menyelesaikan tugas harian.",
    rule2: "2.Hadiah di mall poin diganti secara tidak tetap.",
    rule3:
      "3.Setelah ditukar, poin tidak boleh dikembalikan. Tukar berhati-hati.",
    coins: "Syiling",
    claim: "Tuntut",
    claimed: "Sudah Dituntut",
    notAchieved: "Belum Dicapai",
    reach: "Capai",
  },
  gameRanking: {
    notRanked: "Tidak Berperingkat",
    distanceToRank: "Masih kurang {points} mata untuk mencapai peringkat 50",
    distanceToBeforeRank:
      "Masih kurang {points} mata untuk mencapai peringkat {rankId}",
    rank1: "Anda sudah berada di tempat pertama",
    rules: {
      pointsStats: {
        title: "Peraturan Statistik Poin",
        conversion:
          "1. Piawai Penukaran Poin：1 duit emas bersamaan dengan 1 poin dalam aktiviti, dan poin peserta akan dikira terus berdasarkan bilangan duit emas.",
        timeRange:
          "2. Julat Masa Statistik：Tempoh statistik poin harian ialah 00:00 hingga 23:59 (Zon Masa UTC+8), dan data duit emas yang melebihi julat masa ini akan dimasukkan ke dalam statistik hari berikutnya.",
      },
      ranking: {
        title: "Peraturan Peringkat dan Hadiah",
        basis:
          "3. Asas Peringkat：Sistem akan mengasingkan peserta mengikut urutan menurun berdasarkan jumlah poin akhir harian mereka (iaitu jumlah keseluruhan duit emas pada hari itu) untuk menentukan peringkat harian.",
        rewards: "4. Tetapan Hadiah：",
        reward1: "Peringkat 1: Hadiah 250.000 duit emas",
        reward2: "Peringkat 2: Hadiah 150.000 duit emas",
        reward3: "Peringkat 3: Hadiah 100.000 duit emas",
        reward4: "Peringkat 4: Hadiah 50.000 duit emas",
        reward5: "Peringkat 5: Hadiah 50.000 duit emas",
      },
      distribution: {
        title: "Peraturan Pengedaran Hadiah",
        description:
          "Hadiah yang sepadan dengan peringkat harian akan diedarkan secara seragam pada hari berikutnya. Peserta boleh log masuk ke halaman aktiviti atau akaun peribadi mereka pada hari berikutnya untuk menyemak status penerimaan hadiah.",
      },
      pointsCalculation: {
        description:
          "Perolehan Game minimum 5.000.000 diperlukan untuk layak mendapatkan ganjaran acara.",
      },
      helpReward: {
        description:
          "Bantuan Hadiah: Jika syarat yang sesuai telah dipenuhi tetapi hadiah peringkat tidak ditebus, hadiah bantuan akan diperolehi.",
      },
      turnoverRewards: {
        title: "Peraturan Ganjaran Perolehan",
        turnover: "Perolehan",
        reward: "Ganjaran",
        turnover1M: "1,000,000",
        reward10K: "10,000 Syiling",
        turnover3M: "3,000,000",
        reward30K: "30,000 Syiling",
        turnover5M: "5,000,000",
        reward50K: "50,000 Syiling",
      },
      violation: {
        title: "Peraturan Pelanggaran dan Penalti",
        description:
          "Semasa aktiviti berlangsung, peserta dilarang keras menggunakan kecacatan sistem, plugin, atau sebarang cara lain untuk menipu dengan meng 刷取 (刷取) poin (duit emas). Jika dijumpai:",
        penalty1:
          "5. Pelanggar pertama akan kehilangan kelayakan untuk mendapatkan hadiah hari itu;",
        penalty2:
          "6. Pelanggar dengan keadaan serius atau berulang kali akan dilarang terus mengikuti aktiviti ini dan aktiviti berkaitan selepas ini, dan hak penyertaan tidak akan dipulihkan.",
      },
    },
  },
  luckyAnchorRanking: {
    today: "Hari Ini",
    yesterday: "Kemarin",
    notRanked: "Tidak disenaraikan",
    distanceToRank:
      "Perlu {points} lagi kacang bertuah untuk mencapai 50 teratas",
    distanceToBeforeRank:
      "Perlu {points} lagi kacang bertuah untuk mencapai kedudukan {rankId}",
    rank1: "Anda sudah berada di kedudukan 1",
    rules: {
      activity: {
        title: "Penerangan Aktiviti",
        description:
          "Mengira pendapatan kacang bertuah harian penyampai dan menyusun kedudukan berdasarkan pendapatan ini.",
      },
      ranking: {
        title: "Ganjaran Kedudukan",
        rank: "Kedudukan",
        reward: "Ganjaran Kacang",
        decoration: "Hiasan",
        frameAndBubble: "Bingkai Avatar + Gelembung",
        frameOnly: "Bingkai Avatar",
        requirement:
          "Keperluan minimum untuk ganjaran kedudukan: 150,000 pendapatan kacang bertuah.",
      },
      helpReward: {
        title: "Ganjaran Sokongan",
        description:
          "Pengguna yang tidak menerima ganjaran kedudukan juga boleh mendapat ganjaran sasaran pendapatan kacang bertuah.",
        target: "Sasaran",
        reward: "Ganjaran",
      },
      distribution: {
        title: "Pengagihan Ganjaran",
        description: "Ganjaran akan diagihkan pada hari berikutnya.",
      },
      statistics: {
        title: "Penerangan Statistik",
        description: "Statistik berdasarkan pendapatan kacang bertuah.",
      },
    },
  },

  // Aktiviti Red Envelope Rain
  redEnvelopeRain: {
    countdownTitle: "Kira Mundur Ambil Syiling",
    startNow: "Mula Sekarang",
    rules: "Peraturan",
    timeSlotPrize: "Hadiah Penyertaan Slot Masa",
    winningDetails: "Butiran Kemenangan",
    activityRules: "Peraturan Aktiviti",
    congratulations: "Anda Menang!",
    sorryNoWin: "Maaf, anda tidak menang!",
    coin: "Syiling",
    rulesContent: {
      rule1: "1.Masa Aktiviti: 26 September ~ 15 Oktober",
      rule2:
        "2.Peraturan Aktiviti: Sebelum setiap red envelope dibuka, lengkapkan 3 mesej dalam bilik siaran langsung untuk menerima red envelope.",
      rule3:
        "3.Setiap hari dari 20:00 hingga 00:40 boleh mengambil red envelope, setiap 20 minit sekali.",
      rule4: "4.Boleh menyertai berulang kali dalam slot masa yang berbeza",
      rule5:
        "5.Syiling yang diterima akan diagihkan ke akaun anda secara masa nyata",
    },
    timeStatus: {
      inProgress: "Sedang Berlangsung",
      notStarted: "Belum Bermula",
      finished: "Telah Selesai",
    },
    chatRequirement:
      "Hantar 3 mesej dalam bilik live untuk tuntut, mesej semasa: {count}",
  },

  // Aktiviti Kesatuan
  guildActivity: {
    activityRules: "Peraturan Aktiviti",
    rulesContent: {
      activityTime: "Masa Aktiviti: Bermula 29 September",
      rankingRewards: "Ganjaran Kedudukan",
      requirements: "Keperluan",
      rewardDistribution: "Agihan Ganjaran",
      rewardList: {
        first: "Tempat Pertama: 1,000,000 Kacang Emas",
        second: "Tempat Kedua: 500,000 Kacang Emas",
        thirdToFifth: "Tempat Ke-3-5: 250,000 Kacang Emas",
      },
      requirementText:
        "Penyiar kesatuan mesti menyelesaikan sekurang-kurangnya 30 siaran langsung seminggu. Setiap penyiar yang bersiaran lebih dari 2 jam sehari dikira sebagai satu sesi",
      distributionText: "Ganjaran akan diagihkan pada minggu kedua",
    },
  },

  // Kedudukan Daya Tarikan/Penggunaan
  charmRanking: {
    charmRanking: "Kedudukan Daya Tarikan",
    consumptionRanking: "Kedudukan Penggunaan",
    dailyRanking: "Kedudukan Harian",
    weeklyRanking: "Kedudukan Mingguan",
    userNickname: "Nama Pengguna",
    distanceToPrevious: "Jarak ke Sebelum",
    noRankingData: "Tiada Data Kedudukan",
    requestFailed: "Permintaan Gagal",
  },

  // Aktiviti Jemputan
  inviteActivity: {
    title: "Jemput 3 Orang Pasti Dapat Ganjaran",
    rule: "Peraturan",
    alreadyJoined: "Sudah Menyertai",
    inviteImmediately: "Jemput Sekarang",
    callNumber: "Jemput",
    myRewards: "Ganjaran Saya",
    claim: "Tuntut",
    claimed: "Sudah Dituntut",
    people: "Orang",
    inviteFriends: "Jemput kawan",
    processTitle: "Proses Jemputan:",
    step1: "1. Hantar pautan kepada kawan",
    step2: "2. Kawan muat turun dan daftar",
    step3: "3. Dapatkan syiling percuma",
    rulesTitle: "Peraturan Jemputan",
    rulesContent: {
      rule1: "Apabila menjemput 3 orang, boleh menuntut 16666 kacang emas",
      rule2:
        "Apabila menjemput 25 orang, boleh menuntut lagi 36666 kacang emas",
      rule3:
        "Apabila menjemput 100 orang, boleh menuntut lagi 88888 kacang emas. Jumlah boleh dituntut: 142220 kacang emas.",
      rule4: "Ganjaran dituntut secara manual di halaman aktiviti.",
      rule5:
        "Dilarang keras melakukan penipuan bilangan jemputan dengan sengaja, jika dikesan akan dilakukan penyekatan akaun",
    },
    close: "Tutup",
    inviteFeatureComingSoon: "Fitur jemputan akan segera tersedia",
    rewardReceived: "Berjaya menerima {amount} syiling!",
  },

  // Halaman Hadiah Syiling Emas
  giftGoldCoins: {
    maxGiftableCoins: "Maksimum Syiling Emas Yang Boleh Dihadiahkan",
    giftAmount: "Jumlah Syiling Emas Hadiah",
    customAmount: "Jumlah Syiling Emas Hadiah Tersuai",
    enterAmount: "Masukkan jumlah",
    quantity: "Kuantiti",
    giftToOtherAccounts: "Hadiahkan kepada Akaun Lain",
    exceedMaxAmount:
      "Jumlah tidak boleh melebihi maksimum yang boleh dihadiahkan",
    amountSet: "Jumlah berjaya ditetapkan",
    invalidAmount: "Sila masukkan jumlah yang sah",
    selectValidAmount: "Sila pilih jumlah yang sah",
    confirmTitle: "Sahkan Hadiah",
    confirmMessage: "Adakah anda pasti mahu menghadiahkan {amount} syiling?",
    giftSuccess: "Hadiah berjaya",
    giftId: "ID Hadiah",
    enterGiftId: "Masukkan ID",
    pleaseEnterGiftId: "Sila masukkan ID hadiah",
    giftCompleted: "Hadiah berjaya!",
    giftedToId: "Dihadiahkan kepada ID",
    networkError: "Ralat rangkaian, sila cuba lagi kemudian",
    confirm: "Sahkan",
  },

  // Kedai Hiasan
  shop: {
    headerTitle: "Hiasan Peribadi",
    back: "Kembali",
    shoppingBag: "Beg Beli-belah",
    loading: "Sedang dimuat...",
    noProducts: "Tiada Produk",
    unnamedProduct: "Produk Tanpa Nama",
    day: "Hari",
    myCoins: "Syiling Saya",
    exchangeNow: "Tukar Sekarang",
    notSelected: "Tidak Dipilih",
    loginExpired: "Log masuk telah tamat, sila log masuk semula",
    categoryNotExists: "Kategori tidak wujud",
    loadFailed: "Muat Gagal",
    loadFailedRetry: "Muat gagal, sila cuba lagi",
    pleaseSelectProduct: "Sila pilih produk terlebih dahulu",
    productNotExists: "Produk tidak wujud",
    insufficientCoins: "Syiling tidak mencukupi, perlu {amount} syiling",
    exchangeSuccess: "Tukar Berjaya",
    exchangeFailed: "Tukar Gagal",
    categories: {
      hot: "Popular",
      avatarFrame: "Bingkai Avatar",
      entryEffect: "Kesan Masuk",
      chatBubble: "Buih Sembang",
      mount: "Kenderaan",
    },
    recharge: "Isi Semula >",
    validityPeriod: "Tempoh Sah:",
    myCoinsLabel: "Syiling Saya:",
  },
  myDecoration: {
    headerTitle: "Hiasan Saya",
    back: "Kembali",
    noWearingDecoration: "Tiada hiasan yang dipilih",
    loading: "Sedang dimuat...",
    noDecoration: "Tiada Hiasan",
    unnamedDecoration: "Hiasan Tanpa Nama",
    permanent: "Kekal",
    wearing: "Sedang Dipakai",
    pleaseSelectDecoration: "Sila Pilih Hiasan",
    removeDecoration: "Tanggalkan Hiasan",
    wearNow: "Pakai Sekarang",
    pleaseSelectDecorationFirst: "Sila pilih hiasan terlebih dahulu",
    decorationNotExists: "Hiasan tidak wujud",
    loginExpired: "Log masuk telah tamat, sila log masuk semula",
    loadFailed: "Muat Gagal",
    loadFailedRetry: "Muat gagal, sila cuba lagi",
    wearSuccess: "Pakai Berjaya",
    wearFailed: "Pakai Gagal",
    categories: {
      avatarFrame: "Bingkai Avatar",
      entryEffect: "Kesan Masuk",
      chatBubble: "Buih Sembang",
      mount: "Kenderaan",
    },
  },
  // Aktiviti Krismas/Bintang Bertuah
  christmasActivity: {
    dailyLuckyStar: "Bintang Bertuah Harian",
    weeklyLuckyStar: "Bintang Bertuah Mingguan",
    startTime: "Masa mula:",
    obtainedCount: "Jumlah yang diperoleh",
    moreChance: "Semakin banyak, semakin besar peluang",
    participated: "Met",
    notParticipated: "Unmet",
    historyRecord: "Rekod Sejarah",
    myRecord: "Rekod Saya",
    noRecord: "Tiada rekod",
    loading: "Sedang dimuat...",
    noMore: "Tiada lagi",
    coin: "Syiling",
    goldCoin: "Kacang Emas",
    unit: "buah",
    notWon: "Tidak menang",
    conditionNotMet: "Syarat tidak dipenuhi",
    claimSuccess: "Tuntut berjaya",
    getRecordFailed: "Gagal mendapatkan rekod",
    rules: {
      title: "Peraturan Aktiviti",
      rule1: "Bintang Bertuah Harian",
      rule2: "Aktiviti Bintang Bertuah Harian, semua pengguna boleh menyertai.",
      rule3:
        "Apabila memberikan hadiah yang sepadan kepada hos, bilangan hadiah akan terkumpul. Apabila bilangan hadiah yang diberikan memenuhi keperluan, pengguna boleh menyertai pembukaan sampul merah, dan setiap pembukaan akan ada pengguna bertuah yang menerima ganjaran syiling.",
      rule4:
        "Semakin banyak hadiah yang diberikan, semakin tinggi peluang untuk menang",
      rule5: "Bintang Bertuah Mingguan",
      rule6: "Aktiviti Bintang Bertuah Mingguan, semua hos boleh menyertai.",
      rule7:
        "Apabila menerima hadiah yang sepadan daripada pengguna, bilangan hadiah akan terkumpul. Apabila bilangan hadiah yang diterima memenuhi keperluan, hos boleh menyertai pembukaan sampul merah Bintang Bertuah Mingguan, dan setiap pembukaan akan ada hos bertuah yang menerima ganjaran.",
      rule8:
        "Semakin banyak hadiah yang diterima, semakin tinggi peluang untuk menang",
      rule9: "Nota Lain",
      rule10: "Aktiviti ini adalah program penghargaan kebajikan besar.",
      rule11:
        "Hanya terpakai untuk pengumpulan apabila memberikan hadiah kepada hos lain.",
      rule12:
        "Dilarang keras menggunakan bug/eksploitasi untuk mendapatkan faedah.",
      rule13:
        "Ganjaran untuk setiap tempoh masa akan diedarkan secara automatik. Anda boleh menyemak rekod kemenangan untuk memahami situasi kemenangan.",
    },
  },
  // Aktiviti Kedudukan Mata Bintang Bertuah
  fortuneStarActivity: {
    points: "Mata",
    pointsRanking: "Kedudukan Mata",
    currentRoundPoints: "Mata Pusingan Ini",
    lastRoundPoints: "Mata Pusingan Lalu",
    defaultUserName: "Nama Pengguna",
    noData: "Tiada Data",
    activityRules: "Peraturan",
    historyRecord: "Sejarah",
    earnedPoints: "Mata yang Diperoleh",
    participated: "Telah Menyertai",
    notParticipated: "Tidak Dipenuhi",
    myRecord: "Rekod Saya",
    userId: "ID",
    userNickname: "Nama Samaran Pengguna",
    sessionTime: "Masa Sesi",
    winningStatus: "Status Kemenangan",
    won: "Menang",
    notWon: "Tidak Menang",
    rules: {
      rule1:
        "Semasa acara, pengguna boleh memperoleh mata dengan menghantar hadiah yang ditentukan",
      rule2: "Mata terkumpul secara masa nyata, semak kedudukan mata semasa",
      rule3:
        "Selepas acara berakhir, pengguna yang berada di kedudukan teratas akan menerima ganjaran yang murah hati",
      rule4:
        "Menggunakan sebarang cara menipu untuk memperoleh mata adalah dilarang sama sekali, pelanggar akan dibatalkan kelayakan",
      rule5: "Platform mengekalkan hak tafsiran akhir",
    },
  },

  // Aktiviti Kotak Misteri
  blindBox: {
    title: "Pengenalan Permainan",
    ruleTitle: "Pengenalan Permainan",
    rule1:
      "Setiap {price} syiling boleh membuka {text} sekali, selepas pengguna menghantar hadiah ini, ia boleh berubah menjadi hadiah yang berbeza, dan hadiah yang diubah akan secara automatik dihantar kepada pengguna yang ditentukan di atas pentas",
    rule2:
      "Pengguna yang menghantar {text} boleh mendapat kacang emas yang sepadan selepas hadiah yang diubah dari hadiah ini dihantar secara automatik.",
    rewardTip: "Petua Hadiah",
    probabilityDesc: "Kebarangkalian khusus adalah seperti berikut:",
    prize: "Hadiah",
    probability: "Kebarangkalian",
    value: "Nilai",
  },
  pcOfficial: {
    navHome: "Laman Utama",
    navLive: "Siaran Langsung",
    navGameHall: "Dewan Permainan",
    received: "menerima",
    heroTagline: "Platform Hiburan Web4 Terkemuka Dunia",
    heroTaglineSub:
      "Interaksi masa nyata 24/7 dengan hos terbaik serta pengalaman permainan rantaian blok premium. Berasaskan teknologi terdesentralisasi untuk ganjaran segera dan permainan yang adil.",
    downloadNow: "Muat Turun Sekarang",
    giftCoin: "Syiling EX",
    giftAvatarFrame: "Bingkai Avatar",
    bottomDownloadAndroidApk: "Android APK",
    recommendTitle: "Cadangan Hos Popular",
    recommendSub:
      "Berinteraksi masa nyata dengan ribuan hos terbaik dan nikmati pengalaman permainan P2E",
    hotGamingTitle: "Permainan Popular",
    hotGamingSub:
      "Pemain sebenar, kedudukan sebenar. Adakah anda legenda seterusnya?",
    casinoTitle: "Casino",
    casinoDesc1: "Sertai dealer langsung untuk Baccarat,",
    casinoDesc2: "Roulette dan Blackjack dalam HD",
    slotsTitle: "Slots",
    slotsDesc: "Main ratusan slot premium dengan RTP 98.5%",
    gamingTitle: "Gaming",
    gamingDesc: "Bukan sekadar putaran, nikmati permainan kemahiran berbilang pemain",
    whyTitle: "Mengapa Pilih Rain Live",
    whyItem1Title: "Adil & Saksama",
    whyItem1Desc: "RNG diaudit bagi memastikan permainan yang terbukti adil",
    whyItem2Title: "Bayaran Serta-Merta",
    whyItem2Desc: "Pengeluaran pantas dengan penyelesaian segera",
    whyItem3Title: "Tanpa Nama & Privasi",
    whyItem3Desc: "100% peribadi tanpa memerlukan maklumat peribadi",
    whyItem4Title: "Terdesentralisasi",
    whyItem4Desc: "Permainan on-chain yang selamat dan telus",
    terms: "Terma Perkhidmatan",
    privacy: "Dasar Privasi",
    navRecharge: "Tambah nilai",
    rechargeAccountTitle: "Akaun tambah nilai",
    idLogin: "Log masuk ID",
    accountIdLabel: "ID akaun:",
    accountIdPlaceholder: "Masukkan ID akaun",
    confirm: "Sahkan",
    defaultUserName: "Nama pengguna",
    userIdWithValue: "ID:{id}",
    switchAccount: "Tukar akaun",
    rechargeQuantityTitle: "Jumlah tambah nilai",
    goToPay: "Teruskan bayar",
    topUpAmountTitle: "Jumlah tambah nilai",
    pay: "Bayar",
    channelDefault: "Saluran bayaran",
    toastInvalidAccountId: "Sila masukkan ID akaun yang sah",
    toastNoTokenAfterLogin: "Log masuk berjaya tetapi token tidak diterima",
    toastLoginFailed: "Log masuk gagal",
    toastCoinPackagesFailed: "Gagal memuat senarai pakej syiling",
    toastPayChannelsFailed: "Gagal memuat saluran bayaran",
    toastOrderParamsMissing: "Parameter pesanan hilang, tidak boleh bayar",
    toastNoPayUrl: "URL bayaran tidak dijumpai",
    toastCreateOrderFailed: "Gagal mencipta pesanan bayaran",
    rainLiveRecharge: "Rain Live Tambah nilai",
    selectCountryTitle: "Pilih negara / rantau",
    selectChannelTitle: "Pilih kaedah bayaran",
    rechargeLoading: "Memuatkan...",
    rechargePackagesEmpty: "Tiada pakej tambah nilai buat masa ini",
    rechargeLoginHint: "Sila log masuk dengan ID anda dahulu",
  },
};
